var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "12px",
    viewBox: "0 0 14 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8FFF223F-7B28-45AF-816C-E89B444E7565") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V0.1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "External-Users---GMS_MAZ",
    transform: "translate(-823.000000, -268.000000)",
    stroke: "#B5A6A6",
    strokeWidth: 1.09090909
  }, /*#__PURE__*/React.createElement("g", {
    id: "DropDown",
    transform: "translate(810.000000, 258.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-Ractivate-Icon",
    transform: "translate(14.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.18181818,10 L8.18181818,8.88888889 C8.18181818,7.66158944 7.20498491,6.66666667 6,6.66666667 L2.18181818,6.66666667 C0.976833273,6.66666667 0,7.66158944 0,8.88888889 L0,10",
    id: "Path"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 4.09090909,
    cy: 2.22222222,
    rx: 2.18181818,
    ry: 2.22222222
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "8.72727273 4.44444444 9.81818182 5.55555556 12 3.33333333"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfile);
export default __webpack_public_path__ + "static/media/edit-profile.b5953e7520915f7b7cf8022e9a0d8996.svg";
export { ForwardRef as ReactComponent };